import "./index.css";
// src/ProductDeepLinks/ProductDeepLinks.tsx
import { useState } from "react";
import Button from "@cloudscape-design/components/button";
import ButtonDropdown from "@cloudscape-design/components/button-dropdown";
import Box from "@cloudscape-design/components/box";
import Dropdown from "@amzn/awsui-components-console/dropdown";
import { useAppTranslation } from "@amzn/awsmp-max-translations";
import { appendTrk } from "@amzn/awsmp-max-ux-patterns/TrkTracking";

// src/ProductDeepLinks/ProductDeepLinks.module.scss
var ProductDeepLinks_module_default = {
  container: "ProductDeepLinks_module_container",
  scalingButtons: "ProductDeepLinks_module_scalingButtons",
  buttonWrapper: "ProductDeepLinks_module_buttonWrapper",
  tryFreeButtonWrapper: "ProductDeepLinks_module_tryFreeButtonWrapper",
  aiButtonWrapper: "ProductDeepLinks_module_aiButtonWrapper",
  aiButton: "ProductDeepLinks_module_aiButton",
  proposalMenuItem: "ProductDeepLinks_module_proposalMenuItem",
  dropdownItemIcon: "ProductDeepLinks_module_dropdownItemIcon",
  agentModeActions: "ProductDeepLinks_module_agentModeActions"
};

// src/assets/agent-mode-icon.svg
var agent_mode_icon_default = 'data:image/svg+xml,<svg width="20" height="20" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 9.375C0.00273 11.8606 0.99133 14.2435 2.74889 16.0011C4.50645 17.7587 6.88943 18.7473 9.375 18.75H17.2809C17.6704 18.7495 18.0438 18.5946 18.3192 18.3192C18.5946 18.0438 18.7495 17.6704 18.75 17.2809V9.375C18.75 6.8886 17.7623 4.50403 16.0041 2.74587C14.246 0.98772 11.8614 0 9.375 0C6.8886 0 4.50403 0.98772 2.74587 2.74587C0.98772 4.50403 0 6.8886 0 9.375Z" fill="url(%23homeAgentIconGrad)"></path><path d="M9.3346 4.58203C9.1635 4.58203 9.0098 4.68665 8.947 4.84583L7.8349 7.66564L5.0151 8.77778C4.85592 8.84054 4.7513 8.99429 4.7513 9.16539C4.7513 9.33649 4.85592 9.49024 5.0151 9.55299L7.8349 10.6651L8.947 13.4849C9.0098 13.6441 9.1635 13.7487 9.3346 13.7487C9.5057 13.7487 9.6595 13.6441 9.7222 13.4849L10.8344 10.6651L13.6542 9.55299C13.8134 9.49024 13.918 9.33649 13.918 9.16539C13.918 8.99429 13.8134 8.84054 13.6542 8.77778L10.8344 7.66564L9.7222 4.84583C9.6595 4.68665 9.5057 4.58203 9.3346 4.58203Z" fill="white"></path><defs><radialGradient id="homeAgentIconGrad" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(20.4235 -1.67354) rotate(134.492) scale(39.845 50.9814)"><stop stop-color="%238376FE"></stop><stop offset="0.21" stop-color="%235C7FFF"></stop><stop offset="0.4" stop-color="%238575FF"></stop><stop offset="0.68" stop-color="%23962EFF"></stop></radialGradient></defs></svg>%0A';

// src/NewProjectSection/create-proposal-icon-redesign.svg
var create_proposal_icon_redesign_default = 'data:image/svg+xml,<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M16.6922 6.43281L12.3172 2.05781C12.2591 1.99979 12.1902 1.95378 12.1143 1.92241C12.0384 1.89105 11.9571 1.87494 11.875 1.875H4.375C4.04348 1.875 3.72554 2.0067 3.49112 2.24112C3.2567 2.47554 3.125 2.79348 3.125 3.125V16.875C3.125 17.2065 3.2567 17.5245 3.49112 17.7589C3.72554 17.9933 4.04348 18.125 4.375 18.125H15.625C15.9565 18.125 16.2745 17.9933 16.5089 17.7589C16.7433 17.5245 16.875 17.2065 16.875 16.875V6.875C16.8751 6.7929 16.859 6.71159 16.8276 6.63572C16.7962 6.55985 16.7502 6.4909 16.6922 6.43281ZM12.5 4.00859L14.7414 6.25H12.5V4.00859ZM15.625 16.875H4.375V3.125H11.25V6.875C11.25 7.04076 11.3158 7.19973 11.4331 7.31694C11.5503 7.43415 11.7092 7.5 11.875 7.5H15.625V16.875ZM12.5 11.875C12.5 12.0408 12.4342 12.1997 12.3169 12.3169C12.1997 12.4342 12.0408 12.5 11.875 12.5H10.625V13.75C10.625 13.9158 10.5592 14.0747 10.4419 14.1919C10.3247 14.3092 10.1658 14.375 10 14.375C9.83424 14.375 9.67527 14.3092 9.55806 14.1919C9.44085 14.0747 9.375 13.9158 9.375 13.75V12.5H8.125C7.95924 12.5 7.80027 12.4342 7.68306 12.3169C7.56585 12.1997 7.5 12.0408 7.5 11.875C7.5 11.7092 7.56585 11.5503 7.68306 11.4331C7.80027 11.3158 7.95924 11.25 8.125 11.25H9.375V10C9.375 9.83424 9.44085 9.67527 9.55806 9.55806C9.67527 9.44085 9.83424 9.375 10 9.375C10.1658 9.375 10.3247 9.44085 10.4419 9.55806C10.5592 9.67527 10.625 9.83424 10.625 10V11.25H11.875C12.0408 11.25 12.1997 11.3158 12.3169 11.4331C12.4342 11.5503 12.5 11.7092 12.5 11.875Z" fill="url(%23paint0_radial_proposal)"/>%0A<defs>%0A<radialGradient id="paint0_radial_proposal" cx="0" cy="0" r="1" gradientTransform="matrix(-16.2045 19.1508 -20.7336 -24.5033 18.1023 0.424599)" gradientUnits="userSpaceOnUse">%0A<stop stop-color="%23B8E7FF"/>%0A<stop offset="0.3" stop-color="%230099FF"/>%0A<stop offset="0.45" stop-color="%235C7FFF"/>%0A<stop offset="0.6" stop-color="%238575FF"/>%0A<stop offset="0.8" stop-color="%23962EFF"/>%0A</radialGradient>%0A</defs>%0A</svg>%0A';

// src/ProductDeepLinks/ProductDeepLinks.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var ProductDeepLinks = ({
  pdpUrl,
  procurementUrl,
  requestADemoUrl,
  requestPrivateOfferUrl,
  procureFreeTrialUrl,
  onBuy,
  onTryFree,
  onCreateProposal,
  agentModeActions,
  showInlineActions = false,
  showAcquisitionActions = false,
  fullWidth = true,
  disabled = false,
  logger
}) => {
  const { t } = useAppTranslation();
  const [isAiDropdownOpen, setIsAiDropdownOpen] = useState(false);
  if (showInlineActions) {
    const handleBuyClick = () => {
      logger?.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickSelect: "buy-button"
        }
      });
      onBuy?.();
    };
    const handleTryFreeClick = () => {
      logger?.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickSelect: "try-for-free-button"
        }
      });
      onTryFree?.();
    };
    const handleCreateProposalClick = () => {
      logger?.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickSelect: "create-proposal-button"
        }
      });
      onCreateProposal?.();
    };
    const handleRequestPrivateOfferClick = () => {
      logger?.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickSelect: "request-private-offer-button"
        }
      });
    };
    const handleViewDetailsClick = () => {
      logger?.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickSelect: "view-details-button"
        }
      });
    };
    const showBuy = Boolean(showAcquisitionActions && onBuy && procurementUrl);
    const showRequestPrivateOffer = Boolean(showAcquisitionActions && !procurementUrl && requestPrivateOfferUrl);
    const showViewDetailsFallback = Boolean(showAcquisitionActions && !showBuy && !showRequestPrivateOffer);
    return /* @__PURE__ */ jsxs("div", { className: ProductDeepLinks_module_default.container, children: [
      /* @__PURE__ */ jsxs("div", { className: ProductDeepLinks_module_default.scalingButtons, children: [
        showBuy && /* @__PURE__ */ jsx("div", { className: ProductDeepLinks_module_default.buttonWrapper, children: /* @__PURE__ */ jsx(Button, { disabled, onClick: handleBuyClick, fullWidth: true, children: t("buy") }) }),
        showRequestPrivateOffer && /* @__PURE__ */ jsx("div", { className: ProductDeepLinks_module_default.buttonWrapper, children: /* @__PURE__ */ jsx(
          Button,
          {
            disabled,
            href: appendTrk(requestPrivateOfferUrl),
            target: "_blank",
            iconName: "external",
            iconAlign: "right",
            ariaLabel: `${t("requestPrivateOffer")} (${t("opensInNewTab")})`,
            onClick: handleRequestPrivateOfferClick,
            fullWidth: true,
            children: t("requestPrivateOffer")
          }
        ) }),
        showViewDetailsFallback && /* @__PURE__ */ jsx("div", { className: ProductDeepLinks_module_default.buttonWrapper, children: /* @__PURE__ */ jsx(
          Button,
          {
            disabled,
            href: appendTrk(pdpUrl),
            target: "_blank",
            iconName: "external",
            iconAlign: "right",
            ariaLabel: `${t("viewProductDetails")} (${t("opensInNewTab")})`,
            onClick: handleViewDetailsClick,
            fullWidth: true,
            children: t("viewProductDetails")
          }
        ) }),
        procureFreeTrialUrl && onTryFree && /* @__PURE__ */ jsx("div", { className: ProductDeepLinks_module_default.tryFreeButtonWrapper, children: /* @__PURE__ */ jsx(Button, { disabled, onClick: handleTryFreeClick, fullWidth: true, children: t("tryForFree") }) })
      ] }),
      onCreateProposal && /* @__PURE__ */ jsx("div", { className: ProductDeepLinks_module_default.aiButtonWrapper, children: /* @__PURE__ */ jsx(
        Dropdown,
        {
          open: isAiDropdownOpen,
          onOutsideClick: () => setIsAiDropdownOpen(false),
          onEscape: () => setIsAiDropdownOpen(false),
          trigger: /* @__PURE__ */ jsx(
            "button",
            {
              type: "button",
              className: ProductDeepLinks_module_default.aiButton,
              disabled,
              "aria-label": t("createProposal"),
              "aria-expanded": isAiDropdownOpen,
              "aria-haspopup": "menu",
              onClick: () => setIsAiDropdownOpen(!isAiDropdownOpen),
              children: /* @__PURE__ */ jsx("img", { src: agent_mode_icon_default, alt: "", width: 12, height: 12 })
            }
          ),
          content: /* @__PURE__ */ jsx(Box, { padding: { vertical: "xs", horizontal: "s" }, children: /* @__PURE__ */ jsxs(
            "button",
            {
              type: "button",
              className: ProductDeepLinks_module_default.proposalMenuItem,
              onClick: () => {
                handleCreateProposalClick();
                setIsAiDropdownOpen(false);
              },
              disabled,
              children: [
                /* @__PURE__ */ jsx("img", { src: create_proposal_icon_redesign_default, alt: "", width: 16, height: 16, className: ProductDeepLinks_module_default.dropdownItemIcon }),
                /* @__PURE__ */ jsx("span", { children: t("createProposal") })
              ]
            }
          ) })
        }
      ) })
    ] });
  }
  if (agentModeActions) {
    const primaryAction = procurementUrl ? { url: procurementUrl, text: t("buy"), clickSelect: "buy-button" } : requestPrivateOfferUrl ? { url: requestPrivateOfferUrl, text: t("requestPrivateOffer"), clickSelect: "request-private-offer-button" } : requestADemoUrl ? { url: requestADemoUrl, text: t("requestDemo"), clickSelect: "request-demo-button" } : void 0;
    const logClick = (clickSelect) => {
      logger?.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickSelect: clickSelect
        }
      });
    };
    const menuItemIds = /* @__PURE__ */ new Set(["create-proposal"]);
    for (const action of agentModeActions) {
      if (menuItemIds.has(action.id)) {
        throw new Error(`ProductDeepLinks: agent mode action id "${action.id}" is already in use`);
      }
      menuItemIds.add(action.id);
    }
    const menuItems = [
      ...onCreateProposal ? [{ id: "create-proposal", text: t("createProposal"), iconUrl: create_proposal_icon_redesign_default, iconAlt: "" }] : [],
      ...agentModeActions.map((action) => ({ id: action.id, text: action.text, iconName: action.iconName }))
    ];
    const handleMenuItemClick = (event) => {
      if (event.detail.id === "create-proposal" && onCreateProposal) {
        logClick("create-proposal-button");
        onCreateProposal();
        return;
      }
      const action = agentModeActions.find((candidate) => candidate.id === event.detail.id);
      if (!action)
        return;
      logClick(action.clickSelect ?? action.id);
      action.onClick();
    };
    return /* @__PURE__ */ jsxs("div", { className: ProductDeepLinks_module_default.agentModeActions, children: [
      primaryAction && /* @__PURE__ */ jsx(Button, { href: appendTrk(primaryAction.url), target: "_blank", disabled, onClick: () => logClick(primaryAction.clickSelect), children: primaryAction.text }),
      menuItems.length > 0 && /* @__PURE__ */ jsx(
        ButtonDropdown,
        {
          variant: "icon",
          ariaLabel: t("agentModeActions"),
          items: [{ text: t("agentModeActions"), items: menuItems }],
          onItemClick: handleMenuItemClick,
          disabled
        }
      )
    ] });
  }
  const allItems = [];
  allItems.push({
    id: "view-details",
    text: t("viewProductDetails"),
    href: appendTrk(pdpUrl),
    external: true,
    externalIconAriaLabel: t("opensInNewTab")
  });
  if (procurementUrl) {
    allItems.push({
      id: "view-purchase-options",
      text: t("viewPurchaseOptions"),
      href: appendTrk(procurementUrl),
      external: true,
      externalIconAriaLabel: t("opensInNewTab")
    });
  }
  if (procureFreeTrialUrl) {
    allItems.push({
      id: "try-for-free",
      text: t("tryForFree"),
      href: appendTrk(procureFreeTrialUrl),
      external: true,
      externalIconAriaLabel: t("opensInNewTab")
    });
  }
  if (requestADemoUrl) {
    allItems.push({
      id: "request-demo",
      text: t("requestDemo"),
      href: appendTrk(requestADemoUrl),
      external: true,
      externalIconAriaLabel: t("opensInNewTab")
    });
  }
  if (requestPrivateOfferUrl) {
    allItems.push({
      id: "request-private-offer",
      text: t("requestPrivateOffer"),
      href: appendTrk(requestPrivateOfferUrl),
      external: true,
      externalIconAriaLabel: t("opensInNewTab")
    });
  }
  if (onCreateProposal) {
    allItems.push({
      id: "create-proposal",
      text: t("createProposal"),
      iconName: "gen-ai"
    });
  }
  const items = [
    {
      items: allItems
    }
  ];
  const handleItemClick = (event) => {
    if (event.detail.id === "create-proposal" && onCreateProposal) {
      logger?.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickSelect: "create-proposal-button"
        }
      });
      onCreateProposal();
    }
    if (event.detail.id === "view-details") {
      logger?.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickSelect: "view-details-button"
        }
      });
    }
    if (event.detail.id === "view-purchase-options") {
      logger?.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickSelect: "view-purchase-options-button"
        }
      });
    }
    if (event.detail.id === "try-for-free") {
      logger?.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickSelect: "try-for-free-button"
        }
      });
    }
    if (event.detail.id === "request-demo") {
      logger?.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickSelect: "request-demo-button"
        }
      });
    }
    if (event.detail.id === "request-private-offer") {
      logger?.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickSelect: "request-private-offer-button"
        }
      });
    }
  };
  return /* @__PURE__ */ jsx(ButtonDropdown, { items, variant: "normal", fullWidth, onItemClick: handleItemClick, disabled, children: t("getStarted") });
};
export {
  ProductDeepLinks
};
//# sourceMappingURL=index.js.map
